import { parsePhoneNumber } from "libphonenumber-js/max";
import { NONXRAYMODALITIES } from "../constants/Constants";

export const validatePhoneNumber =(inputNumber, country, t) => {
    const actualPhoneNumber = inputNumber.substring(country.dialCode.length);
    if(actualPhoneNumber.length !== 0){
      try {
        const phoneNumber = parsePhoneNumber( actualPhoneNumber, country.iso2.toUpperCase());
        if (phoneNumber) {
          if(!phoneNumber.isValid())
            return (`${t("string-literals.invalid-number")}`);
        }
      } catch (error) {
        return (`${t("string-literals.invalid-number")}`);
      }
    }
  }

  export const validatePhoneNumberWithCode =(inputNumber, countryCode, dialCode, t) => {
    if(inputNumber && countryCode && dialCode){
      const actualPhoneNumber = inputNumber.substring(dialCode.length +1);
      if(actualPhoneNumber.length !== 0){
        try {
          const phoneNumber = parsePhoneNumber( actualPhoneNumber, countryCode.toUpperCase());
          if (phoneNumber) {
            if(!phoneNumber.isValid())
              return (`${t("string-literals.invalid-number")}`);
          }
        } catch (error) {
          return (`${t("string-literals.invalid-number")}`);
        }
      }
    }
  }

  export const opneWeasisViewer=(studyId) =>{
    console.log(" study ID ", studyId);
    const weasisapi_URL = process.env.REACT_APP_DICOM_ACCEPTOR_BASE_URL + `"weasis/study/${studyId}/manifest"`;
    const url = `$dicom:get -w ${weasisapi_URL}`;
    console.log("weasis url", url);
    
    const encodedURL = encodeURIComponent(url);
    const weasisURL = "weasis://" + encodedURL;
    console.log(weasisURL);

    var wordInstance = document.createElement("a");
    wordInstance.id = "weasisStudy";
    var link = document.createTextNode("weasis link");
    wordInstance.appendChild(link);
    wordInstance.title = "ms-word";
    wordInstance.href = weasisURL;
    wordInstance.click();

  }

  export const openInfinitViewer=(accessionNumber,infinitViewerUrl) =>{
    // console.log(" accessionNumber ", accessionNumber);
    // const infinitViewerUrl = "https://pacs.carepointhealth.com/pkg_pacs/external_interface.aspx?TYPE=V&LID=cphaugmento&LPW=TEST123test&AN="+"A003990967BNJ";
    console.log(infinitViewerUrl);
    const newTab = window.open(infinitViewerUrl, '_blank');

  }

  export const generateRandomString=(userId, studyId) =>{
    return userId + "-" + studyId + "-" + Math.random().toString(36).substring(2, 10);
  }

  export const isChestXrayStudy = (modality, studyDescription) => {
    return NONXRAYMODALITIES.includes(modality) && studyDescription?.toUpperCase().includes('CHEST');
};